<template>
  <FriedSearchInput
    ref="searchBoxRef"
    :model-value="searchInput"
    class="search-box"
    :placeholder="placeholder"
    @update:model-value="handleInput"
  >
    <template #left>
      <FriedIcon icon="search" />
    </template>
    <template v-if="searching" #right>
      <FriedSpinner v-if="searching" class="search-loader" :size="20" />
    </template>
    <template v-else-if="searchInput" #right>
      <FriedIconButton
        v-tooltip="{
          content: t('clear-search'),
          placement: TooltipPlacement.Bottom,
          delay: { show: 300, hide: 100 },
        }"
        class="clear-search-button"
        data-external="add-content-clear-search-button"
        @click="handleClearInput"
        @keydown.prevent.down.up
      >
        <FriedIcon :size="IconSize.Small" icon="close" />
      </FriedIconButton>
    </template>
  </FriedSearchInput>
</template>
<script lang="ts">
import type { Ref } from 'vue';
import { ref, defineComponent } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { IconSize, Placement as TooltipPlacement } from '@getaccept/fried-tofu';

export default defineComponent({
  name: 'SearchContent',
  props: {
    searching: { type: Boolean, default: false },
    placeholder: { type: String, required: true },
  },
  emits: ['search'],
  setup(_, { emit }) {
    const { t } = useI18n();
    const searchInput = ref('');
    const searchBoxRef: Ref<HTMLInputElement> = ref(null);

    const handleSearch = () => {
      emit('search', searchInput.value);
    };

    const handleClearInput = () => {
      emit('search', '');
      searchInput.value = '';
    };

    const debounceSearch = useDebounceFn(handleSearch, 200);

    const handleInput = (text: string) => {
      searchInput.value = text;
      debounceSearch();
    };

    return {
      handleClearInput,
      handleSearch,
      handleInput,
      searchInput,
      searchBoxRef,
      TooltipPlacement,
      IconSize,
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
.search-box {
  flex: none;

  .search-loader {
    margin-right: var(--spacing-100);
  }

  .clear-search-button {
    margin-right: var(--spacing-50);
  }
}
</style>
